/**
 * ブログ記事編集画面のフィールドをタブのUIで表示します。
 *
 * @param {Object} options
 * @param {Array} options.content タブに入れるフィールドとラベルを指定したオブジェクトを要素に持つ配列
 * @param {String} options.pointer `#title-field` などのセレクタ
 * @param {String} options.method `before` or `after`
 */
import { temporaryId } from './temporaryId.js';

export function tabs(options) {
    const defaultOptions = {
        content: [],
        pointer: '',
        method: 'after'
    };
    const op = Object.assign({}, defaultOptions, options);

    const tabCount = op.content.length;
    const pointerElement = document.querySelector(op.pointer);

    if (tabCount === 0 || op.pointer === '' || !pointerElement) {
        return;
    }

    let tabHead = [];
    let tabBody = [];

    for (let i = 0; i < tabCount; i++) {
        let activeClass = i === 0 ? ' show active' : '';
        if (typeof op.content[i].id === 'undefined') {
            op.content[i].id = temporaryId('tab-');
        }
        tabHead.push(`
            <li class="nav-item">
                <a class="nav-link${activeClass}" data-bs-toggle="tab" href="#${op.content[i].id}" role="tab">
                    ${op.content[i].label}
                </a>
            </li>
        `);
        tabBody.push(`<div class="tab-pane fade${activeClass}" id="${op.content[i].id}" role="tabpanel"></div>`);
    }

    const tabsHtml = `
        <div class="card text-center my-6">
            <div class="card-header">
                <ul class="nav nav-tabs card-header-tabs" role="tablist">
                    ${tabHead.join('')}
                </ul>
            </div>
            <div class="card-body tab-content text-left">
                ${tabBody.join('')}
            </div>
        </div>
    `;

    if (op.method === 'before') {
        pointerElement.insertAdjacentHTML('beforebegin', tabsHtml);
    } else {
        pointerElement.insertAdjacentHTML('afterend', tabsHtml);
    }

    for (let i = 0; i < tabCount; i++) {
        let tabId = op.content[i].id;
        const targetTab = document.getElementById(tabId);
        op.content[i].selector.split(',').forEach((selector) => {
            let target = document.querySelector(selector);
            if (target) {
                targetTab.appendChild(target);
            }
        });
    }
}
